import { render } from "./Qiehuan.vue?vue&type=template&id=19b48c26&scoped=true"
import script from "./Qiehuan.vue?vue&type=script&lang=js"
export * from "./Qiehuan.vue?vue&type=script&lang=js"

import "./Qiehuan.vue?vue&type=style&index=0&id=19b48c26&scoped=true&lang=scss"

import exportComponent from "D:\\peizhe_protal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19b48c26"]])

export default __exports__